import { Ref } from 'vue';
import { SmallBusinessStore, SmallBusinessStoreInterface } from '@/application/smallBusiness/infrastructure/store/SmallBusinessStore';
import { usePlocState, getStore } from '@hfc/ui-core';

interface UseSmallBusinessStoreInterface {
  smallBusinessStore: SmallBusinessStore;
  smallBusinessState: Ref<SmallBusinessStoreInterface>;
}

export const useSmallBusinessStore = (): UseSmallBusinessStoreInterface => {
  const smallBusinessStore = getStore<SmallBusinessStore>('SmallBusinessStore', SmallBusinessStore);
  const smallBusinessState = usePlocState(smallBusinessStore) as Ref<SmallBusinessStoreInterface>;

  return {
    smallBusinessStore,
    smallBusinessState,
  };
};
